import { WaterStationThreshold } from './WaterStationThreshold'

export class WaterStationLegend {
  constructor(readonly titleTranslationKey: string, readonly thresholds: WaterStationThreshold[]) {}

  get thresholdCount(): number {
    return this.thresholds.length
  }

  getColorByState(hasData: boolean, isSelected: boolean): string {
    const state = `${hasData ? 'data' : 'nodata'}_${isSelected ? 'selected' : 'unselected'}`
    const threshold = this.thresholds.find((t) => t.state === state)
    return threshold?.color || '#808080' // Fallback to gray
  }
}
